<template>
    <div class="panel-content">
        <h2>Onze trots</h2>
        <img class="header" src="/static/img/overlay-assets/header3-3.jpg" />
        <p>Wij zijn er trots op dat we al diverse apparaten hebben mogen ontwikkelen voor het zuiveren van isotopen en het vervaardigen van radioactief gelabelde medicijnen, welke gebruikt worden in het onderzoek naar revolutionaire behandelingsmethoden. We hebben het hierbij voor elkaar gekregen om zelfs zeer complexe radiochemische productiestappen volledig te automatiseren.</p>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
    export default {

    };
</script>
